import { render } from "./Claim3_Eval.vue?vue&type=template&id=4aab140e&scoped=true"
import script from "./Claim3_Eval.vue?vue&type=script&lang=js"
export * from "./Claim3_Eval.vue?vue&type=script&lang=js"

import "./Claim3_Eval.vue?vue&type=style&index=0&id=4aab140e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4aab140e"

export default script